
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/a/[city]/[artist_id]",
      function () {
        return require("private-next-pages/a/[city]/[artist_id].js");
      }
    ]);
  